<div fxLayout="column" fxFlex="1 1 auto">
    <div fxFlex="60px">
        <neq-header></neq-header>
    </div>
    <div fxFlex>
        <router-outlet></router-outlet>
    </div>
    <div *ngIf="!isIE" fxFlex="45px">
        <neq-footer></neq-footer>
    </div>
</div>
